import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3fe93046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container mb-6" }
const _hoisted_2 = { class: "fixed-content-container" }
const _hoisted_3 = { class: "header pb-2" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "font-weight-black" }
const _hoisted_6 = { class: "header-tool-icons" }
const _hoisted_7 = {
  ref: "collapsableContentContainer",
  class: "collapsable-content-container"
}
const _hoisted_8 = { style: {"overflow":"hidden"} }
const _hoisted_9 = { class: "body pb-1" }
const _hoisted_10 = { class: "font-weight-black" }
const _hoisted_11 = {
  key: 0,
  class: "body pb-1"
}
const _hoisted_12 = { class: "font-weight-black" }
const _hoisted_13 = { class: "body" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_15 = { class: "alert-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.userCanEditFormItems)
        ? (_openBlock(), _createBlock(_component_v_tooltip, {
            key: 0,
            activator: "parent",
            location: "center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('i18n.editNotAvailable')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, {
              class: "item-icon cursor-move",
              icon: "mdi-drag-vertical",
              size: "large"
            }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('i18n.textInputTitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.duplicateItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "$GoRateDuplicate" }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.duplicate')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.removeItem,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  icon: "$GoRateDeleteOutline"
                }),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.remove')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_v_btn, {
              class: "cursor-pointer",
              variant: "text",
              icon: "",
              onClick: _ctx.expandGrid,
              disabled: !_ctx.userCanEditFormItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: _ctx.expandGridButtonIconName,
                  size: "large"
                }, null, 8, ["icon"]),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "start"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('i18n.collapse')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('i18n.language1')), 1),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.itemData.question_lang1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemData.question_lang1) = $event)),
              density: "compact",
              placeholder: _ctx.$t('i18n.questionLang1'),
              variant: "outlined",
              dense: "",
              "hide-details": "auto",
              clearable: "",
              counter: "",
              rules: _ctx.questionRules,
              disabled: !_ctx.userCanEditFormItems
            }, null, 8, ["modelValue", "placeholder", "rules", "disabled"])
          ]),
          (_ctx.bilingual)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('i18n.language2')), 1),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.itemData.question_lang2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.question_lang2) = $event)),
                  density: "compact",
                  placeholder: _ctx.$t('i18n.questionLang2'),
                  variant: "outlined",
                  dense: "",
                  "hide-details": "auto",
                  clearable: "",
                  counter: "",
                  rules: _ctx.questionRules
                }, null, 8, ["modelValue", "placeholder", "rules"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_v_textarea, {
              class: "pt-1",
              label: _ctx.$t('i18n.userAnswerLabel'),
              variant: "outlined",
              disabled: "",
              rows: "3",
              counter: ""
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_v_alert, {
              class: "mt-3 mb-3 alert",
              variant: "outlined",
              type: "warning",
              dense: "",
              closable: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('i18n.alertTablets')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 512)
    ]),
    _createVNode(_component_v_divider, {
      thickness: 2,
      class: "border-opacity-100 mb-3",
      color: "grey"
    })
  ], 64))
}